import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-thankyou-page-marketing',
  templateUrl: './thankyou-page-marketing.component.html',
  styleUrls: ['./thankyou-page-marketing.component.scss']
})
export class ThankyouPageMarketingComponent implements OnInit {
  constructor(
    private router: Router,
  ) {

  }

  ngOnInit(): void {

  }

  goToAboutUs() {
    this.router.navigate(['/aboutUs'])
  }
}
